module.exports = __webpack_public_path__ + "static/media/three_quarters_left_back_picture.30cdf1f1.jpg";